import {BrowserModule} from '@angular/platform-browser'
import {NgModule, Provider} from '@angular/core'
import {AppRoutingModule} from './app-routing.module'

import {FormsModule} from '@angular/forms'
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import {registerLocaleData} from '@angular/common'
import en from '@angular/common/locales/en'
import {SharedModule} from './shared/shared.module'
import {PipesModule} from './shared/pipes.module'

import {AuthInterceptor} from './shared/auth.interceptor'

import {PreloaderService} from './shared/components/preloader/preloader.service'
import {NotificatorService} from './shared/services/notificator.service'

// Content Components
import {AuthService} from './shared/services/auth.service'
import {AppComponent} from './app.component'
import {PreloaderComponent} from './shared/components/preloader/preloader.component'
import {CacheService} from './shared/services/cache.service'
import {RateService} from './shared/services/rate.service'
import {CompaniesEtc} from './shared/services/cache.etc/companies'
import {CategoriesEtc} from './shared/services/cache.etc/categories'
import {SchedulesEtc} from './shared/services/cache.etc/schedules'
import {RatesEtc} from './shared/services/cache.etc/rates'
import {VacationPackagesEtc} from './shared/services/cache.etc/vacation.packages'
import {VendorsEtc} from './shared/services/cache.etc/vendors'
import {BreadcrumbsService} from './shared/components/main-layout/breadcrumbs.service'
import {AngularEditorModule} from '@kolkov/angular-editor'
import {CookieService} from 'ngx-cookie-service'
import {IdbCache} from './shared/services/cache.etc/idb.cache'
import {AccessLevelService, AuthGuard} from './shared/services/acl.service'
import {SystemUpdateService} from './shared/services/system-update.service'
import {provideEnvironmentNgxMask} from 'ngx-mask'

registerLocaleData(en)

const INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  multi: true,
  useClass: AuthInterceptor
}

@NgModule({ declarations: [
        AppComponent,
        PreloaderComponent,
        // PhoneMaskDirective
    ],
    bootstrap: [AppComponent],
    exports: [], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        SharedModule,
        PipesModule,
        AngularEditorModule], providers: [
        provideEnvironmentNgxMask(),
        INTERCEPTOR_PROVIDER,
        AuthService,
        PreloaderService,
        NotificatorService,
        CacheService,
        RateService,
        BreadcrumbsService,
        CompaniesEtc,
        CategoriesEtc,
        SchedulesEtc,
        RatesEtc,
        VacationPackagesEtc,
        VendorsEtc,
        IdbCache,
        CookieService,
        AccessLevelService,
        AuthGuard,
        SystemUpdateService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
